import { Role } from '@guiker/permissions'

import { LeaseRoleNames } from '../../entity'
import { LeaseActions } from '../lease-actions'

export const LesseeRole: Role = {
  name: LeaseRoleNames.LESSEE,
  permissions: [{ action: LeaseActions.SignLeaseAsLessee }, { action: LeaseActions.ViewLease }],
}
